import Repository from "./Repository";

const CHANNEL = "channel";

export default {
  getChannels(payload) {
    return Repository.get(transformRoute(CHANNEL), { params: payload });
  }
};

const transformRoute = route => {
  return `/user/${route}`;
};
